module.exports = "/static/assets/e43a45d146c95cb23ba247257578a260.png";